import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
import { params, string, shape } from '@thd-nucleus/data-sources';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { CountdownTimer } from '@thd-olt-component-react/countdown-timer';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import * as analytics from './analytics/PromotionsAnalytics';
import './promotion.style.scss';

const Promotion = ({ itemId, hideConditionalPromoDescription }) => {
  const { channel } = useContext(ExperienceContext);
  const storeId = useStoreId();
  const { data, loading } = useProductDeprecated({ itemId, storeId, domains: ['pricing'] });
  // const { data, loading } = useDataModel('product', { variables: { itemId, storeId } });

  if (loading || !data) return null;

  const { description, dates } = data?.product?.pricing?.promotion || {};

  if (hideConditionalPromoDescription) return null;

  const { shortDesc, longDesc } = description || {};

  if (!shortDesc) return null;

  const { end, start } = dates || {};

  return (
    <div>
      {shortDesc !== 'Online Exclusive Special Buy of the Day' && (
        <>
          <div className="promotion">
            <Tooltip
              channel={channel}
              content={(
                <div>
                  <b>Promotion Details</b>
                  <div className="promotion__tooltip">{`Price Valid: ${start} - ${end}`}</div>
                  {longDesc && <div>{longDesc}</div>}
                  {!longDesc && <div>{shortDesc}</div>}
                </div>
              )}
              closeButton
            >
              <button
                type="button"
                className="promotion__link"
                href="#"
                onClick={analytics.promoClickEvent}
              >
                {shortDesc}
              </button>
            </Tooltip>
          </div>
        </>
      )}
      {shortDesc === 'Online Exclusive Special Buy of the Day' && (
        <>
          <div className="promotion__sbotd-wrapper">
            <div className="promotion__sbotd-teaser-icon" />
            <div>
              <div className=" promotion__sbotd-timer">Special Buy ends in&nbsp;
                <CountdownTimer
                  endDate={end}
                  shouldShowSecondsRemaining
                  isSBOTD
                />
              </div>
              <a className="promotion__sbotd-link" href="/SpecialBuy/SpecialBuyOfTheDay">
                Shop All Special Buy of the Day
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

Promotion.displayName = 'Promotion';

Promotion.dataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    pricing: params({ storeId: string() }).shape({
      promotion: shape({
        dates: shape({
          start: string(),
          end: string()
        }),
        description: shape({
          shortDesc: string(),
          longDesc: string()
        }),
      })
    })
  })
};

Promotion.propTypes = {
  itemId: PropTypes.string.isRequired,
  hideConditionalPromoDescription: PropTypes.bool
};

Promotion.defaultProps = {
  hideConditionalPromoDescription: false
};

export default Promotion;
